import axios from "axios";
import { faFileUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, Col, Form, Row, Table, Toast, ToastContainer } from "react-bootstrap";
import { JAlerta, JCaption, JRow, JTBody, JTHead } from "../../components/Components";
import auxService from "../../services/AuxService";
import { useEffect, useRef, useState } from "react";
import { CertificadoInterface, TenantInterface } from "../../interfaces";
import { useForm } from "react-hook-form";
import { BASE_URL } from "../../api/api";
import { formatDate } from "../../utils/utils";
const initialState: TenantInterface = {
    id: 0,
    name: '',
    grupo: '',
    data_vencimento: '',
    active: false,
    limite_empresas: 0
}

const FormConfig: React.FC = () => {
    const [tenant, setTenant] = useState<TenantInterface>(initialState)
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const [certificados, setCertificados] = useState<CertificadoInterface[]>([]);
    const { register, handleSubmit, reset, formState: { errors } } = useForm<CertificadoInterface>();
    const [showError, setShowError] = useState<boolean>(false);
    const [showMessageError, setShowMessageError] = useState<string>('');
    const [variantMessage, setVariantMessage] = useState<string>('success');

    const onSubmit = async (data: CertificadoInterface) => {
        if (data.arquivo?.length === 0) {
            return;
        }

        const api = axios.create({
            baseURL: BASE_URL,
            headers: {
                "Content-Type": "multipart/form-data",
                "Accept": "application/json",
                "Cache-Control": "no-cache",
            },
            withCredentials: true,
            withXSRFToken: true
        });

        api.interceptors.request.use(
            async config => {
                const token = localStorage.getItem('token');
                const empresa = localStorage.getItem('empresa') || '0';

                if (token !== "") {
                    config.headers["Authorization"] = `Bearer ${token}`;
                    config.headers["manifesto-empresa-logada"] = empresa;
                }
                return config;
            },
            (error) => {
                return Promise.reject(error);
            }
        );

        const formData = new FormData();
        formData.append("password", data.password ?? '');
        if (data.arquivo) {
            formData.append("arquivo", data.arquivo[0]);
        }
        api.post('certificados', formData).then(res => {
            if (res.status === 201) {

                setShowMessageError('Certicado carregado com sucesso.');
                setVariantMessage('success');
                setShowError(true);
                reset({
                    cpfcnpj: '',
                    name: '',
                    password: '',
                    id: 0,
                    validade: ''
                })
                certificados.unshift({
                    cpfcnpj: res.data.cpfcnpj,
                    id: res.data.id,
                    name: res.data.name,
                    validade: res.data.validade.date
                }
                )

                if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                }
            } else {
                setShowMessageError('Houve algum erro na requisição.');
                setVariantMessage('danger');
                setShowError(true);
            }
        }).catch(error => {
            setShowMessageError(error.response.data.message);
            setVariantMessage('danger');
            setShowError(true);
        });

    }

    useEffect(() => {
        auxService.getTenant().then(res => {
            setTenant(res);

        }).catch((error) => console.log(error))
        auxService.getCertificados().then(res => {

            setCertificados(res.data);
        }).catch((error) => console.log(error))


    }, [])

    return (<>
        <Row>
            <Col>
                <ToastContainer position="top-end" className="p-3" style={{ zIndex: 1 }}>
                    <Toast bg={variantMessage} onClose={() => setShowError(false)} show={showError} delay={5000} autohide>
                        <Toast.Header>
                            <strong className="me-auto">{variantMessage === "danger" ? "Error!": "Sucesso!"}</strong>
                        </Toast.Header>
                        <Toast.Body className="text-light fw-bold">{showMessageError}</Toast.Body>
                    </Toast>

                </ToastContainer>
                <Card className="shadow card-primary card-outline">
                    <Card.Header>Configuração</Card.Header>

                    <Card.Title className="text-center">
                        {/* <JAlerta showError={showError} close={setShowError} messageError={showMessageError}
                            variant={variantMessage} time={3000} /> */}
                    </Card.Title>
                    <Card.Body>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <JRow className="mb-3">
                                <Col md>
                                    <Form.Group>
                                        <Form.Label>Nome do grupo empresarial</Form.Label>
                                        <Form.Control type="text" disabled name="name" value={tenant?.name} />
                                    </Form.Group>
                                </Col>
                                <Col md={3}>
                                    <Form.Group>
                                        <Form.Label>CNPJ Raíz</Form.Label>
                                        <Form.Control type="text" disabled name="grupo" value={tenant?.grupo} />
                                    </Form.Group>
                                </Col>
                                <Col md={'auto'}>
                                    <Form.Group>
                                        <Form.Label>Número de licença</Form.Label>
                                        <Form.Control type="text"
                                            disabled name="grupo" value={tenant?.limite_empresas} />
                                    </Form.Group>
                                </Col>
                            </JRow>
                            <JRow className="mb-3">
                                <Col md>
                                    <Form.Group>
                                        <Form.Label>Cerfificado Digital (A1)</Form.Label>
                                        <Form.Control type="file"
                                            className={`form-control ${errors.arquivo ? "is-invalid" : ""}`}
                                            accept=".pfx" {...register("arquivo", { required: "Campo obrigatório" })}
                                            ref={(e: any) => {
                                                register("arquivo").ref(e);
                                                fileInputRef.current = e;
                                            }}
                                        />
                                        {errors.arquivo &&
                                            <div className="invalid-feedback">{errors.arquivo.message}</div>
                                        }
                                    </Form.Group>
                                </Col>
                                <Col md>
                                    <Form.Group>
                                        <Form.Label>Senha do certificado</Form.Label>
                                        <Form.Control type="password" defaultValue={''}
                                            className={`form-control ${errors.password ? "is-invalid" : ""}`}
                                            {
                                            ...register(
                                                "password",
                                                {
                                                    required: "Campo obrigatório",
                                                    minLength:
                                                    {
                                                        value: 4,
                                                        message: "A senha deve ter no mínimo 4 caracteres"
                                                    }
                                                })
                                            } />
                                        {errors.password &&
                                            <div className="invalid-feedback">{errors.password.message}</div>
                                        }
                                    </Form.Group>
                                </Col>
                            </JRow>

                            <JRow className="mb-3">
                                <Col md={'auto'} className="me-auto">
                                    <Form.Group>
                                        <Button type="submit">
                                            <FontAwesomeIcon icon={faFileUpload} /> Carregar certificado
                                        </Button>
                                    </Form.Group>
                                </Col>
                            </JRow>
                        </form>

                        <JCaption title="Lista de Certificados" />
                        <Table responsive bordered striped size="sm">
                            <JTHead>

                                <tr>
                                    <th>Certificado</th>
                                    <th className="text-center">CPF/CNPJ</th>
                                    <th className="text-center">Validade</th>
                                </tr>

                            </JTHead>
                            <JTBody>
                                {certificados?.map(i => (
                                    <tr key={i.id}>
                                        <td>{i.name}</td>
                                        <td className="text-center">{i.cpfcnpj}</td>
                                        <td className="text-center">{formatDate(i.validade)}</td>

                                    </tr>
                                ))}
                            </JTBody>
                        </Table>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    </>)
}
export default FormConfig;
